import { cva } from 'class-variance-authority';
import { Check, Info, TriangleAlert, X } from 'lucide-react';
import type { AlertProps, AlertVariant } from './types';

export const alertVariants = cva(
  'eye:relative eye:grid eye:w-full eye:grid-cols-[auto_1fr] eye:items-start eye:gap-x-4xs eye:gap-y-4xs eye:rounded-md eye:p-xs',
  {
    variants: {
      variant: {
        info: 'eye:bg-blue-25 eye:[&>button]:hover:bg-blue-50',
        error: 'eye:bg-red-25 eye:[&>button]:hover:bg-red-50',
        warning: 'eye:bg-yellow-35 eye:[&>button]:hover:bg-yellow-100',
        success: 'eye:bg-green-25 eye:[&>button]:hover:bg-green-50',
      },
    },
    defaultVariants: {
      variant: 'info',
    },
  },
);

export const variantIcons: Record<AlertVariant, AlertProps['icon']> = {
  info: Info,
  error: X,
  warning: TriangleAlert,
  success: Check,
};

export const variantIconColors: Record<AlertVariant, string> = {
  info: 'eye:text-blue-150',
  warning: 'eye:text-olive-100',
  success: 'eye:text-green-100',
  error: 'eye:text-red-100',
};
